<!--新版本结算中心-->
<!--先判断是否已经绑定银行卡，然后再判断是否达到提现门槛-->
<template>
  <div class="wrapdraw-wrapper">
    <!-- <div class="announcement">
      <div class="annoce-desc">
        说明：新版结算中心于2月28日上线，并自动将原有收益折算为可提现金额。换算前原有各类型收益请点击【查看明细】。
      </div>
      <div class="click-detail" @click="clickDetail">查看明细</div>
      <div class="click-annoce">
        <a href="https://dev-wiki.mini1.cn/news/2060" target="_blank">
          查看公告</a
        >
      </div>
    </div> -->
    <!--提现金额-->
    <div class="wrapdraw-box">
      <div class="content-wrap">
        <div class="content">
          <img src="@/assets/images/money_logo.png" class="imgPic" />
          <div class="desc">可提现金额</div>
          <div class="mValue">
            <span class="value1">{{ money }} </span>
            <span class="bean">元</span>
          </div>
        </div>

        <!-- 紧急添加提示 -->
        <!-- <div class="tips-err">
          <a href="https://dev-wiki.mini1.cn/news/2310">
            开发者您好，由于2023年2月收益数据量较大，导致系统跑数较慢，预估收益于4月5日前到账，抱歉给您带来不便！
          </a>
        </div> -->

        <!--判断是否绑定银行卡-->
        <div class="bind" v-if="binding">
          <!--已经绑定银行卡-->
          <el-row class="button1" v-if="canWithdraw">
            <el-button type="warning" @click="getMoney">提现</el-button>
          </el-row>
          <el-row class="button2" v-else>
            <el-button type="warning" disabled>提现</el-button>
          </el-row>
        </div>
        <!--未绑定银行卡-->
        <div class="bind" v-else>
          <el-row class="button1">
            <el-button type="warning" @click="bingCard">绑定银行卡</el-button>
          </el-row>
        </div>
      </div>
      <div class="intro" v-if="canWithdraw">
        可提现余额门槛为{{ money_min }}元
      </div>
      <div class="intro" v-else>达到{{ money_min }}元可提现</div>
    </div>
    <!--提现迷你豆-->
    <div class="wrapdraw-box">
      <div class="content-wrap">
        <div class="content">
          <img src="@/assets/images/minibean.png" class="imgPic" />
          <div class="desc1">迷你豆</div>
          <div class="mValue1">
            <span class="value1">{{ minibean }} </span>
            <span class="bean">豆</span>
          </div>
        </div>
        <!--迷你豆提现-->
        <div class="bind">
          <el-row class="button1" v-if="minibean > 0">
            <el-button type="warning" @click="getMinibean">
              提取到游戏
            </el-button>
          </el-row>
          <el-row class="button2" v-else>
            <el-button type="warning" disabled>提取到游戏</el-button>
          </el-row>
          <!-- <el-row class="button1" v-if="canMinibean">
            <el-button type="warning" @click="getMinibean"
              >提取到游戏</el-button
            >
          </el-row>
          <el-row class="button2" v-else>
            <el-button type="warning" disabled>提取到游戏</el-button>
          </el-row> -->
        </div>
        <!-- <div class="bind" v-else>
          <el-row class="button1">
            <el-button
              type="warning"
              @click="$router.push({ name: 'settlementSet' })"
              >绑定银行卡</el-button
            >
          </el-row>
        </div> -->
      </div>
      <!-- <div class="intro">每月额度{{ minibean_month_max }}</div> -->
      <!--二期先屏蔽额度限制-->
      <div class="intro"><br /></div>
    </div>
    <div class="intro-wrap">
      <div class="title">结算说明</div>
      <div class="desc">
        1.
        当月的收益数据平台会在N+2月1日确认，并到账个人结算中心的可提现金额及迷你豆之中。
      </div>
      <div class="desc">
        2.
        可提现金额达到100元后可以提取，提取前请先绑定银行卡信息，提现后将在7个工作日内到账。
      </div>
      <div class="desc">
        3. 迷你豆可以提取到游戏之中，目前暂不限制每月额度。
      </div>
      <div class="desc">
        4. 个人用户到账金额为平台代扣代征税的税后金额，结算记录中可查看明细。
      </div>
      <div class="desc">
        5. 提现时间为每周一至周五工作时间10:00-18:00，其他时间暂不支持。
      </div>
      <div class="desc-bottom">
        查看具体详情：
        <a href="https://dev-wiki.mini1.cn/news/2069" target="_blank">
          《迷你平台结算规则说明》</a
        >
      </div>
    </div>
    <!--余额提现弹窗-->
    <!-- <detail-dialog :openBillDialog="openBillDialog" :detailInfo="detailInfo">
    </detail-dialog> -->
    <!--迷你豆提现弹窗-->
    <form-dialog
      :showWithdrawForm="showWithdrawForm1"
      :withdrawInfo="withdrawInfo"
      @closeWithdrawForm="closeWithdrawForm"
    >
    </form-dialog>
    <!--查看明细公告-->
    <div class="look-detail">
      <el-dialog :visible.sync="lookVisible" width="770px" title="结算明细">
        <div class="detail-content">
          <div class="title">2022-01-01日前未结算收益</div>
          <div class="content">
            <span class="mtitle">广告收入</span>
            <span class="value">{{ ad }}元</span>
          </div>
          <div class="content">
            <span class="mtitle">贡献点收入</span>
            <span class="value">{{ contribution }}元</span>
          </div>
          <div class="content">
            <span class="mtitle">迷你点折算收入</span>
            <span class="value">{{ minipoint }}元</span>
          </div>
          <div class="content">
            <span class="mtitle">其他收入</span>
            <span class="value">{{ other }}元</span>
          </div>
          <div class="conclusion-box">
            <div class="conclusion">合计</div>
            <div class="conclusion-value">{{ sumValue }}元</div>
          </div>
          <div class="conclusion-box">
            <div class="conclusion">迷你豆收入</div>
            <div class="conclusion-value">{{ sumMinibean }}</div>
          </div>
          <div class="sumbit" @click="closeDialog">
            <el-button type="warning" size="medium">确认</el-button>
          </div>
          <div class="detail-desc">
            <span class="desc">
              结算明细统计1月1日前，广告、贡献点、迷你点、其他收入中未提现的全部收益，并根据兑换比例进行折算。详细请查看
            </span>
            <a
              href="https://mnweb.mini1.cn/activity/docs/settlement_proto_20210521.html"
              target="_blank"
              >《迷你平台结算规则说明》</a
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
  <!-- <openBillDialog>  </openBillDialog> -->
</template>
<script>
// import DetailDialog from '../withdraw/detailDialog.vue';
import FormDialog from '../withdraw/formDialog.vue';
import { mapState } from 'vuex';
import { fetchIncomeView, fetchBillDetail } from '@/api/income';
export default {
  data() {
    return {
      money: 0,
      binding: true,
      canWithdraw: true,
      canMinibean: true,
      // openBillDialog: false,
      lookVisible: false,
      showWithdrawForm1: false,
      money_min: 0,
      sumMinibean: 0,
      ad: 0,
      minibean: 0,
      contribution: 0,
      minipoint: 0,
      other: 0,
      minibean_max: '',
      minibean_month_max: 0,
      sumValue: 0,
      detailInfo: {},
      ArrValue: [
        {
          title: '广告收入',
          value: 0,
        },
        {
          title: '贡献点收入',
          value: 0,
        },
        {
          title: '迷你点折算收入',
          value: 0,
        },
        {
          title: '其他收入',
          value: 0,
        },
      ],
      withdrawInfo: {},
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState(['bankInfo', 'developerInfo']),
  },
  methods: {
    init() {
      if (this.bankInfo.bank_card) {
        this.binding = true;
      } else {
        this.binding = false;
      }
      this.getInomeView();
    },
    async getInomeView() {
      try {
        const res = await fetchIncomeView({ dtype: 1 });
        this.money = res.data.money;
        this.money_min = res.data.money_min;
        this.minibean = res.data.minibean;
        this.minibean_month_max = res.data.minibean_month_max;
        if (this.money > this.money_min || this.money === this.money_min) {
          this.canWithdraw = true;
        } else {
          this.canWithdraw = false;
        }
        if (
          this.minibean > this.minibean_month_max ||
          this.minibean === this.minibean_month_max
        ) {
          this.canMinibean = true;
        } else {
          this.canMinibean = false;
        }
      } catch (error) {
        console.error();
      }
    },
    // async fetchSettlementOverview() {
    //   try {
    //     const res = await getSettlementOverview();
    //     需求排序：3,1,4,2,5
    //     let { list } = res.data;
    //     let newList = [];
    //     const sortRules = [3, 1, 4, 2, 5];
    //     sortRules.forEach(num => {
    //       const item = list.find(item => item.type === num);
    //       newList.push({ ...item });
    //     });
    //     this.cardArr = res.data;
    //     this.detailInfo = res.data.detailInfo;
    //     this.withdrawInfo = res.data.withdrawInfo;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    clickDetail() {
      this.getDataList();
      this.lookVisible = true;
    },
    closeDialog() {
      this.lookVisible = false;
    },
    //提现余额
    getMoney() {
      this.showWithdrawForm1 = true;
      this.withdrawInfo.num = this.money;
      this.withdrawInfo.min = this.money_min;
      this.withdrawInfo.type = 1;
    },
    //绑定银行卡
    bingCard() {
      if (this.developerInfo.phone) {
        this.$router.push({ name: 'settlementSet' });
      } else {
        this.$message.error('您还未绑定手机号，请去【账号管理】绑定手机号');
      }
    },
    //提现迷你豆，根据传入数据不同区分
    getMinibean() {
      this.showWithdrawForm1 = true;
      this.withdrawInfo.num = this.minibean;
      this.withdrawInfo.type = 2;
    },
    //获取收益概览数据
    async getDataList() {
      const res = await fetchBillDetail();
      this.ad = res.data.ad;
      this.contribution = res.data.contribution;
      this.minipoint = res.data.minipoint;
      this.other = res.data.other;
      this.sumMinibean = res.data.minibean;
      this.sumValue = (
        res.data.ad +
        res.data.contribution +
        res.data.minipoint +
        res.data.other
      ).toFixed(2);
    },
    closeWithdrawForm(val) {
      this.showWithdrawForm1 = val;
      this.getInomeView();
    },
  },
  components: { FormDialog },
};
</script>
<style lang="scss" scoped>
.wrapdraw-wrapper {
  .announcement {
    width: 993px;
    height: 48px;
    background: #fffaed;
    display: flex;
    margin-bottom: 20px;
    padding: 16px 28px 13px 14px;
    .annocedesc {
      vertical-align: middle;
    }
    .annoce-desc {
      font-size: 14px;
      color: #595959;
    }
    .click-detail {
      margin-left: 27px;
      margin-right: 28px;
      padding: 6px 8px;
      width: 70px;
      height: 29px;
      margin-top: -6px;
      margin-bottom: 4px;
      background: #ffffff;
      border-radius: 2px;
      color: #323232;
      font-size: 12px;
      border: 1px solid #e1e1e1;
      cursor: pointer;
      line-height: 17px;
    }
    .click-annoce {
      padding: 6px 8px;
      width: 70px;
      line-height: 17px;
      margin-top: -6px;
      margin-bottom: 4px;
      background: #ffffff;
      height: 29px;
      border-radius: 2px;
      font-size: 12px;
      border: 1px solid #e1e1e1;
      cursor: pointer;
      a {
        color: #323232;
        font-size: 12px;
        text-decoration: none;
      }
    }
  }
  .wrapdraw-box {
    margin-bottom: 24px;
    margin-top: 12px;
    padding: 13px 42px 12px 28px;
    border: 1px solid #e8edf7;
    background: #fcfdff;
    border-radius: 4px;
    font-size: 16px;
    .content-wrap {
      display: flex;
      align-items: center;
      position: relative;
      .content {
        display: flex;
        flex: 1;
        .desc {
          padding-top: 12px;
          margin-left: 14px;
          font-size: 20px;
          color: #000000;
        }
        .desc1 {
          padding-top: 18px;
          margin-left: 14px;
          font-size: 20px;
          color: #000000;
        }
        .imgPic {
          height: 52px;
          padding-top: 16px;
          width: 36px;
        }
        .el-tooltip {
          margin-top: 9px;
          margin-right: 18px;
        }
        .mValue {
          margin-left: 10px;
          color: #fd9b21;
          display: flex;
          .value1 {
            font-size: 32px;
          }
          .bean {
            font-size: 16px;
            display: flex;
            align-items: flex-end;
            padding-bottom: 12px;
            margin-left: 6px;
          }
        }
        .mValue1 {
          margin-left: 10px;
          color: #fd9b21;
          padding-top: 6px;
          display: flex;
          .value1 {
            font-size: 32px;
          }
          .bean {
            font-size: 16px;
            display: flex;
            align-items: flex-end;
            padding-bottom: 6px;
            margin-left: 6px;
          }
        }
      }
      .tips-err {
        width: 447px;
        position: absolute;
        right: 141px;
        top: 13px;
        font-size: 14px;
        a {
          text-decoration: none;
          color: red;
        }
      }

      .bind {
        .button1.el-row {
          margin-top: 12px;
          border-radius: 4px;
          border: 1px solid #ffc973;
        }
        .button2.el-row {
          margin-top: 12px;
        }
        .el-button.el-button--warning {
          padding-top: 5px;
          text-align: center;

          padding-bottom: 4px;
          width: 134px;
          font-size: 18px;
          border: none;
          background: #fffaed;
          line-height: 25px;
          color: #fd9b21;
        }
        .el-button.el-button--warning.is-disabled {
          //ba
          background: #d9d9d9;
          color: #fffaed;
          border-color: none;
        }
      }
    }

    .intro {
      margin-left: 50px;
      margin-top: -14px;
      font-size: 14px;
      color: #bfbfbf;
      line-height: 28px;
    }
  }
  .intro-wrap {
    margin-top: 36px;
    .title {
      color: #262626;
      font-size: 18px;
      margin-bottom: 24px;
    }
    .desc {
      font-size: 14px;
      line-height: 15px;
      color: #8c8c8c;
      margin-bottom: 12px;
    }
    .desc-bottom {
      color: #262626;
      a {
        text-decoration: none;
        color: #fd9b21;
      }
    }
    margin-bottom: 600px;
  }
  .look-detail {
    ::v-deep.el-dialog {
      border-radius: 8px;
    }
    ::v-deep.el-dialog__header {
      text-align: center !important;
      padding-bottom: 0px;
      .el-dialog__title {
        color: #262626;
        font-size: 24px;
      }
    }
    ::v-deep.el-dialog__body {
      padding: 40px 133px 26px 115px;
    }
    ::v-deep.el-dialog__headerbtn {
      display: none;
    }
    .detail-content {
      color: #262626;
      .title {
        font-size: 24px;
        color: #262626;
        margin-bottom: 10px;
      }
      .content {
        display: flex;
        font-size: 16px;
        padding-top: 14px;
        .mtitle {
          display: flex;
          flex: 1;
          color: #595959;
          font-size: 16px;
        }
      }
      .conclusion-box {
        margin-top: 14px;
        font-size: 24px;
        color: #262626;
        display: flex;
        .conclusion {
          display: flex;
          flex: 1;
        }
      }
      .sumbit {
        margin-top: 82px;
        text-align: center;
        //padding-bottom: 20px;
        //color: #262626;
        .el-button--medium {
          padding: 10px 60px 8px 60px;
          color: #ffffff;
          font-size: 20px;
        }
      }
      .detail-desc {
        margin-top: 119px;
        text-align: center;
        .desc {
          font-size: 16px;
        }
        a {
          text-decoration: none;
          font-size: 16px;
          color: #2b6ddf;
          //padding-bottom: 24px;
        }
      }
    }
  }
}
</style>
